import type { CoreTenant, CoreTenantSite } from '../types';

const SITE_HUES = [210, 160, 30, 280, 0, 190, 120, 340];

export function siteHue(siteId?: string | null): number {
  if (!siteId) return 220;
  let hash = 0;
  for (let i = 0; i < siteId.length; i += 1) {
    hash = (hash * 31 + siteId.charCodeAt(i)) >>> 0;
  }
  return SITE_HUES[hash % SITE_HUES.length];
}

export function findTenant(tenants: CoreTenant[], tenantId?: string | null): CoreTenant | undefined {
  if (!tenantId) return undefined;
  return tenants.find(tenant => tenant.id === tenantId);
}

export function findSite(
  tenant: CoreTenant | undefined,
  siteId?: string | null,
): CoreTenantSite | undefined {
  if (!tenant || !siteId) return undefined;
  return tenant.sites.find(site => site.tenantSiteId === siteId || site.id === siteId);
}

export function tenantDisplayName(
  tenants: CoreTenant[],
  tenantId?: string | null,
): string {
  return findTenant(tenants, tenantId)?.name ?? (tenantId ? 'Unknown tenant' : 'No tenant');
}

export function siteDisplayName(
  tenants: CoreTenant[],
  tenantId?: string | null,
  siteId?: string | null,
): string {
  if (!siteId) return 'No site';
  return findSite(findTenant(tenants, tenantId), siteId)?.name ?? 'Unknown site';
}

export function sitesForTenant(tenants: CoreTenant[], tenantId?: string | null): CoreTenantSite[] {
  const tenant = findTenant(tenants, tenantId);
  return (tenant?.sites ?? []).filter(site => site.enabled !== false);
}

export function firstEnabledSite(tenant?: CoreTenant | null): CoreTenantSite | undefined {
  return (tenant?.sites ?? []).find(site => site.enabled !== false);
}
